import useMediaQuery from "@material-ui/core/esm/useMediaQuery";
import { useTheme } from '@material-ui/core/styles';
import ChevronRight from "@material-ui/icons/esm/ChevronRight";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { BILISTA_AD_LINK } from 'constants/urls';
import desktopAd from '../images/bilista_ad_desktop.png';
import mobileAd from '../images/bilista_ad_mobile.png';
import useStyles from './styles';
export default function BilistaAd() {
  const theme = useTheme();
  const {
    t
  } = useTranslation();
  const {
    bilistaOverviewCardLabel,
    bilistaOverviewCard
  } = useStyles();
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'));
  return /*#__PURE__*/React.createElement("a", {
    href: BILISTA_AD_LINK
  }, /*#__PURE__*/React.createElement("div", {
    className: bilistaOverviewCard
  }, /*#__PURE__*/React.createElement("img", {
    src: isDesktop ? desktopAd : mobileAd,
    alt: "Bilista Ad",
    title: t('home.bilista_ad'),
    style: {
      maxWidth: '100%'
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: bilistaOverviewCardLabel
  }, t('home.bilista_ad_label'), /*#__PURE__*/React.createElement(ChevronRight, null))));
}